import React from "react";
import { Box, Checkbox, Stack } from "@mui/material";
import { Playlist } from "../../types/Playlist";
import { Artist } from "../../types/Artist";
import { Album } from "../../types/Album";
import { Track } from "../../types/Track";

type PlaylistItemProps = {
    playlist: Playlist,
    artist: Artist | undefined,
    album: Album | undefined,
    track: Track | undefined,
    checked: boolean,
    checkboxChange: (checked: boolean) => void,
}

const PlaylistItem = (props: PlaylistItemProps) => {
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => props.checkboxChange(event.target.checked);

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <Box>
                <Checkbox checked={props.checked} onChange={handleCheckboxChange} />
            </Box>
            <Box>
                {props.playlist.name}
            </Box>
        </Stack>
    )
}

export default PlaylistItem;